import { combineReducers } from '@reduxjs/toolkit'
import { login } from "./loginReducer"

const authReducers = combineReducers({
  login
})

export default authReducers